import React, { createContext, useContext } from 'react';
import { ACTIVE_SEASONS, SEASON_PHASE } from './seasons';
import { SEASON_LABELS } from './seasonLabels';

// Create the context
const SeasonContext = createContext();

// Provider component that wraps your app and makes season data available
export const SeasonProvider = ({ children }) => {
  // Function to check if a specific sport is active
  const isSeasonActive = (sport) => ACTIVE_SEASONS[sport] === true;
  
  // Get an array of all active sports
  const activeSports = Object.keys(ACTIVE_SEASONS).filter(sport => ACTIVE_SEASONS[sport]);

  // Calendar phase for a sport that has no live boards. An active sport is
  // always 'live' regardless of what SEASON_PHASE says, so the two maps can
  // never contradict each other on screen.
  const getSeasonPhase = (sport) =>
    (ACTIVE_SEASONS[sport] === true ? 'live' : (SEASON_PHASE[sport] || 'off'));

  // Season year label, e.g. '2026-27'. Empty string for an unknown sport so
  // callers interpolate nothing rather than "undefined".
  const getSeasonLabel = (sport) => SEASON_LABELS[sport] || '';

  // Context value with season utilities
  const value = {
    activeSeasons: ACTIVE_SEASONS,
    isSeasonActive,
    activeSports,
    getSeasonPhase,
    getSeasonLabel
  };
  
  return (
    <SeasonContext.Provider value={value}>
      {children}
    </SeasonContext.Provider>
  );
};

// Custom hook to use the season context
export const useSeason = () => {
  const context = useContext(SeasonContext);
  if (context === undefined) {
    throw new Error('useSeason must be used within a SeasonProvider');
  }
  return context;
}; 